import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, tap, filter, withLatestFrom } from 'rxjs/operators';
import * as Action from './actions'
import { ToastService } from '../../services/toast.service';
import { SubscriptionService } from 'app/services/dal/subscription.service';
import { Router } from '@angular/router';
import { selectBarId } from '../user/reducer';
import * as fromUser from 'app/state/user/reducer';
import { Store } from '@ngrx/store';



@Injectable()
export class SubscriptionEffects {

  constructor(
    private router: Router,
    private actions$: Actions,
    private service: SubscriptionService,
    private store: Store,
    private toastService: ToastService) { }

  gotoSupbscription$ = createEffect(
    () => {
      return this.actions$
        .pipe(
          ofType(Action.gotoSubscribe),
          tap(() => {
            this.router.navigate(['subscription']);
          }),
        )
    },
    { dispatch: false }
  );

  getSubscription$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadItem),
        mergeMap((action) => this.service.getSubscription(action.barId)
          .pipe(
            map(item => Action.loadItemSuccess({ item: item })),
            catchError(error => of(Action.loadItemFailure({ error })))
          )
        )
      );
  });



}
